import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const shippingInfoManifest: FeatureManifest = {
  id: 'orders-shipping-info',
  path: 'orders/shipping-info',
  navPath: '/orders/shipping-info',
  label: 'Địa chỉ',
  requiredPermissions: ['orders'],
  navigationGroup: { id: 'orders', label: 'Quản lý đơn hàng' },
  load: () => import('./entry'),
}
